const ADMIN_ROLES = Object.freeze(['app-administrator', 'client-administrator', 'system-administrator'])
const PLATFORM_ADMIN_ROLES = Object.freeze(['app-administrator', 'system-administrator'])

const MODULE_ROLES = {
  action_tracker: {
    roles: [...ADMIN_ROLES, 'at-user', 'at-leader', 'at-master'],
    settings: [...ADMIN_ROLES],
  },

  leadership_assessment: {
    roles: [
      ...ADMIN_ROLES,
      'la-admin',
      'la-client-pm',
      'la-participant-leader',
      'la-coach',
      'la-consultant',
    ],
    settings: [...ADMIN_ROLES, 'la-admin'],
  },

  bpo: {
    roles: [
      ...ADMIN_ROLES,
      'bpo-reporter',
      'bpo-manager',
      'bpo-dashboard',
      'bpo-action-tracker-reporter',
      'bpo-action-tracker-coverage-approver',
      'bpo-action-tracker-planner',
      'bpo-action-tracker-supervisor',
      'bpo-action-tracker-performer',
      'bpo-action-tracker-director',
      'bpo-action-tracker-admin',
      'bpo-supervisor',
    ],
    surveyjs: [...ADMIN_ROLES, 'bpo-survey-js'],
    settings: [...ADMIN_ROLES, 'bpo-manager'],
  },

  coaching_tracker: {
    roles: [
      ...ADMIN_ROLES,
      'ctr-admin',
    ],
    settings: [...ADMIN_ROLES, 'ctr-admin'],
  },

  incident_observation_analytics: {
    roles: [
      ...ADMIN_ROLES,
      'incident-obs-analytics-Viewer',
    ],
    settings: [...ADMIN_ROLES],
  },

  core: {
    roles: [...ADMIN_ROLES],
  },

  incident_management: {
    roles: [
      ...ADMIN_ROLES,
      'im-user',
      'im-investigator',
      'im-approver',
      'im-admin',
      'im-soft-admin',
    ],
    status_label: [...ADMIN_ROLES, 'im-investigator', 'im-approver', 'im-admin', 'im-soft-admin'],
    settings: [...ADMIN_ROLES, 'im-admin', 'im-soft-admin'],
  },

  learning_lens: {
    roles: [...ADMIN_ROLES],
    settings: [...ADMIN_ROLES],
  },

  maturity_grids: {
    roles: [...ADMIN_ROLES],
    settings: [...ADMIN_ROLES],
  },

  risk_profiling: {
    roles: [
      ...ADMIN_ROLES,
      'risk-profiling-admin',
      'risk-profiling-catalogue-admin',
      'risk-profiling-user',
      'risk-profiling-view',
    ],
    settings: [...ADMIN_ROLES, 'risk-profiling-admin', 'risk-profiling-catalogue-admin'],
  },

  new_risk_profiling: {
    roles: [
      ...ADMIN_ROLES,
      'risk-management-admin',
      'risk-management-consultant',
      'risk-dashboard-viewer',
      'risk-checklist-taker',
      'risk-checklist-schedule-manager',
      'risk-checklist-adhoc-manager',
    ],
    settings: [...ADMIN_ROLES, 'risk-management-admin'],
    dashBoardViewer: [...ADMIN_ROLES, 'risk-dashboard-viewer'],
    checklistTaker: [...ADMIN_ROLES, 'risk-checklist-taker'],
    checklistScheduleManager: [...ADMIN_ROLES, 'risk-checklist-schedule-manager'],
    checklistAdHocManager: [...ADMIN_ROLES, 'risk-checklist-adhoc-manager'],
  },

  risk_catalogue: {
    roles: [
      ...ADMIN_ROLES,
      'risk-catalogue-admin',
      'risk-catalogue-user',
    ],
    settings: [...ADMIN_ROLES, 'risk-catalogue-admin'],
  },

  safety_observation: {
    roles: [
      ...ADMIN_ROLES,
      'safety-observation-user',
      'safety-observation-leader',
      'safety-observation-master',
      'safety-observation-admin',
      'safety-observation-dashboard',
    ],
    settings: [...ADMIN_ROLES, 'safety-observation-admin'],
  },

  spi: {
    roles: [...ADMIN_ROLES, 'spi-user', 'spi-admin', 'spi-master', 'spi-leader', 'spi-dashboard'],
    settings: [...ADMIN_ROLES, 'spi-admin'],
  },

  sps: {
    roles: [...ADMIN_ROLES, 'sps-admin', 'sps-consultant', 'sps-reviewer'],
    settings: [...ADMIN_ROLES, 'sps-admin'],
  },

  target_scheduling: {
    roles: [
      ...ADMIN_ROLES,
      'spi-master',
      'safety-observation-master',
      'targeting-admin',
      'absence-admin',
    ],
    settings: [...ADMIN_ROLES, 'targeting-admin'],
  },

  target_scheduling_home: {
    roles: [
      ...ADMIN_ROLES,
      'spi-user',
      'safety-observation-user',
      'targeting-admin',
      'spi-leader',
      'spi-master',
    ],
    settings: [...ADMIN_ROLES],
  },

  spi_goals: {
    roles: [...ADMIN_ROLES, 'targeting-admin', 'spi-leader', 'spi-master'],
    settings: [...ADMIN_ROLES, 'targeting-admin'],
  },

  safety_observation_goals: {
    roles: [
      ...ADMIN_ROLES,
      'targeting-admin',
      'safety-observation-leader',
      'safety-observation-master',
      'absence-admin',
    ],
    settings: [...ADMIN_ROLES, 'targeting-admin'],
  },

  training_management: {
    roles: [...ADMIN_ROLES],
    settings: [...ADMIN_ROLES],
  },

  unsafe_conditions: {
    roles: [...ADMIN_ROLES, 'sc-dashboard', 'sc-responsible', 'sc-support', 'sc-user'],
    settings: [...ADMIN_ROLES],
  },

  wcv: {
    roles: [...ADMIN_ROLES, 'wc-supervisor', 'wc-coordinator', 'wc-leader', 'wc-dashboard'],
    settings: [...ADMIN_ROLES],
  },

  action_tracker_v2: {
    roles: [...ADMIN_ROLES],
    settings: [...ADMIN_ROLES],
    completeSideMenu: [...ADMIN_ROLES, 'act2-manager', 'act2-admin'],
    onlyMyActions: ['act2-user'],
  },

  consultant_visit: {
    roles: [...ADMIN_ROLES, 'cva-admin', 'cva-project-manager', 'cva-consultant'],
    settings: [...ADMIN_ROLES, 'cva-admin', 'cva-project-manager'],
    companionDashboards: [...ADMIN_ROLES, 'cva-companion-dashboards', 'cva-admin'],
  },

  generic_survey: {
    roles: [...ADMIN_ROLES, 'generic-survey-creator'],
  },

  massive_import: {
    roles: [...ADMIN_ROLES, 'mass-import-admin', 'mass-import-user'],
    destinations: [...PLATFORM_ADMIN_ROLES, 'mass-import-admin'],
  },

  dashboard: {
    roles: [...ADMIN_ROLES, 'dashboard-manager', 'tm-dashboard', 'im-dashboard', 'risk-profiling-dashboard', 'bpo-dashboard', 'safety-observation-dashboard', 'spi-dashboard', 'sc-dashboard', 'wc-dashboard', 'user-dashboard-01', 'user-dashboard-02', 'user-dashboard-03', 'user-dashboard-04', 'user-dashboard-05', 'user-dashboard-06', 'user-dashboard-07', 'user-dashboard-08', 'user-dashboard-09', 'user-dashboard-10', 'user-dashboard-11', 'user-dashboard-12', 'user-dashboard-13', 'user-dashboard-14', 'user-dashboard-15', 'user-dashboard-16', 'user-dashboard-17', 'user-dashboard-18', 'user-dashboard-19', 'user-dashboard-20'],
    settings: [...ADMIN_ROLES],
  },

  dashboards_v2: {
    roles: ['superset-manager'],
    viewer: ['superset-viewer'],
  },

  utrakk: {
    roles: ['utrakk'],
  },
}

Object.freeze(MODULE_ROLES)

Object.freeze(MODULE_ROLES)

function getAllRoles() {
  return Object.values(MODULE_ROLES).flatMap(module => [
    ...(module.roles || []),
    ...(module.settings || []),
    ...(module.viewer || []),
  ])
}

export { ADMIN_ROLES, MODULE_ROLES as default, getAllRoles, PLATFORM_ADMIN_ROLES }
